import type { MbtiCode } from './types';

/**
 * 診断4軸コード（サイト）↔ Drive画像コード ↔ タイプ名の1:1正本
 * Drive: https://drive.google.com/drive/folders/1EVFRJmkj9N8vI7AeIhwaigV_exs7qcuw（16種・共用なし）
 */
export interface SiteDriveImageEntry {
  siteCode: MbtiCode;
  /** Driveファイル名の先頭コード（例: PRAE） */
  driveCode: string;
  /** タイプ名（Driveファイル名・画面表示の正本） */
  typeName: string;
}

export const SITE_DRIVE_IMAGE_MAP: readonly SiteDriveImageEntry[] = [
  { siteCode: 'PALE', driveCode: 'PALE', typeName: 'グルメ弾丸ハンター' },
  { siteCode: 'PALZ', driveCode: 'PALZ', typeName: '美食のんびり族' },
  { siteCode: 'PACE', driveCode: 'PRAE', typeName: '完璧弾丸トラベラー' },
  { siteCode: 'PACZ', driveCode: 'PRCZ', typeName: '究極の安心旅行者' },
  { siteCode: 'PRLE', driveCode: 'PRCE', typeName: '安定志向冒険家' },
  { siteCode: 'PRLZ', driveCode: 'PRAZ', typeName: '計画的隠居旅人' },
  { siteCode: 'PRCE', driveCode: 'PCLE', typeName: 'バランス型探検家' },
  { siteCode: 'PRCZ', driveCode: 'PCLZ', typeName: 'ほどほど快適派' },
  { siteCode: 'SALE', driveCode: 'SRAE', typeName: '爆速即興トラベラー' },
  { siteCode: 'SALZ', driveCode: 'SRAZ', typeName: '風まかせビーチ族' },
  { siteCode: 'SACE', driveCode: 'SRCE', typeName: 'ゆるふわアドベンチャー' },
  { siteCode: 'SACZ', driveCode: 'SRCZ', typeName: '究極の脱力系' },
  { siteCode: 'SRLE', driveCode: 'SALE', typeName: '食い倒れ冒険' },
  { siteCode: 'SRLZ', driveCode: 'SALZ', typeName: 'グルメ放浪詩人' },
  { siteCode: 'SRCE', driveCode: 'SCLE', typeName: '自由放浪遊牧民' },
  { siteCode: 'SRCZ', driveCode: 'SCLZ', typeName: '窮境のマイペース' },
] as const;

export const DRIVE_IMAGE_COUNT = SITE_DRIVE_IMAGE_MAP.length;
